import { footerLinks } from '@/mocks/homepage';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setEmail('');
      return;
    }
    const formData = new FormData(form);
    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'website_alt') params.append(key, value as string);
    });

    fetch('https://readdy.ai/api/form/d90ha2s6ci2plld1odkg', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    })
      .then(() => {
        setEmail('');
        alert('订阅成功！');
      })
      .catch(() => {
        alert('订阅失败，请稍后再试～');
      });
  };

  return (
    <footer className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 md:gap-16">
          <div className="lg:w-[40%]">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 leading-tight">
              爆料专区
              <br />
              吃瓜基地
            </h2>
            <p className="text-sm text-foreground-500 mt-4 max-w-sm leading-relaxed">
              全网独家免费吃瓜基地，每日不间断更新最新黑料与八卦
            </p>

            <form
              data-readdy-form
              id="footer-subscribe-form"
              onSubmit={handleSubmit}
              className="mt-10 max-w-xs"
            >
              <label className="text-xs text-foreground-500 mb-2 block">
                输入邮箱获取每日热点
              </label>
              <div className="flex flex-col gap-3">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="w-full pb-2 bg-transparent border-b border-foreground-300 text-foreground-950 text-sm outline-none focus:border-foreground-950 transition-colors placeholder:text-foreground-400"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="absolute opacity-0 pointer-events-none"
                />
                <button
                  type="submit"
                  className="inline-flex items-center justify-center px-6 py-2.5 border border-foreground-300 text-foreground-800 text-sm font-semibold rounded-lg hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all whitespace-nowrap cursor-pointer"
                >
                  立即订阅
                </button>
              </div>
            </form>
          </div>

          <div className="lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 gap-8 md:gap-10">
            {[footerLinks.col1, footerLinks.col2, footerLinks.col3].map((col, colIndex) => (
              <div key={colIndex}>
                {col.map((link) => (
                  <a
                    key={link.label}
                    href={link.href}
                    className="block text-sm text-foreground-500 hover:text-foreground-950 transition-colors leading-[2.5] whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 md:mt-20 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 爆料专区 · 全网独家免费吃瓜基地 · 版权所有
          </p>
          <p className="text-xs text-foreground-400">
            本网站内容均来自网络公开信息，不代表本站立场
          </p>
        </div>
      </div>
    </footer>
  );
}